import {gql, useMutation} from '@apollo/client';
import {Action} from 'components/Assistant/hooks/reducer';

export interface Vars {
	id?: string
	message: string
	subject: string
}

interface Result {
	assistant: {
		interviewer: {
			id: string

			fromUser: {
				messages: []
				error?: string
			}
		}
	}
}

const query = gql`
mutation (
	$id: ID,
	$message: String!,
	$subject: String!,
) {
	assistant {
		interviewer(id: $id, subject: $subject) {
			id

			fromUser(message: $message) {
				messages {
					id
					source
					message
					created {
						unix
					}
				}

				error
			}
		}
	}
}
`;

export const useSendUser = (dispatch: React.Dispatch<Action>) => (
	useMutation<Result, Vars>(query, {
		onCompleted: (result, options) => {
			const {fromUser} = result.assistant.interviewer;
			if (fromUser.error) {
				dispatch({
					type: 'ERROR',
					counter: options?.context?.counter || 0,
				});
				return;
			}

			dispatch({
				type: 'RESULT',
				id: result.assistant.interviewer.id,
				messages: fromUser.messages,
				counter: options?.context?.counter || 0,
			});
		},
		onError: (_, options) => {
			dispatch({
				type: 'ERROR',
				counter: options?.context?.counter || 0,
			});
		},
	})
);
